interface OAuthButtonProps {
  provider: 'google' | 'linkedin';
  onClick: () => void;
  children: React.ReactNode;
}

export default function OAuthButton({ provider, onClick, children }: OAuthButtonProps) {
  const getButtonStyles = () => {
    switch (provider) {
      case 'google':
        return 'mt-4 w-full flex items-center justify-center gap-2 py-3 bg-white border border-gray-300 rounded-lg shadow hover:bg-gray-50 cursor-pointer transition';
      case 'linkedin':
        return 'mt-3 w-full flex items-center justify-center gap-2 py-3 bg-[#0077b5] text-white font-semibold rounded-lg shadow hover:bg-[#005983] cursor-pointer transition';
      default:
        return '';
    }
  };

  const getIcon = () => {
    switch (provider) {
      case 'google':
        return (
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
        );
      case 'linkedin':
        return (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20.447 20.452h-3.554V14.77c0-1.353-.026-3.093-1.889-3.093-1.892 0-2.182 1.477-2.182 3v5.775H9.267V9h3.414v1.561h.049c.476-.899 1.637-1.849 3.371-1.849 3.602 0 4.269 2.368 4.269 5.451v6.289zM5.337 7.433c-1.144 0-2.07-.926-2.07-2.07 0-1.144.926-2.07 2.07-2.07 1.144 0 2.07.926 2.07 2.07 0 1.144-.926 2.07-2.07 2.07zM7.119 20.452H3.554V9h3.565v11.452zM22.225 0H1.771C.792 0 0 .771 0 1.729v20.542C0 23.229.792 24 1.771 24h20.451C23.207 24 24 23.229 24 22.271V1.729C24 .771 23.207 0 22.225 0z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <button type="button" onClick={onClick} className={getButtonStyles()}>
      {getIcon()}
      <span className={provider === 'google' ? 'text-gray-700 font-semibold' : ''}>{children}</span>
    </button>
  );
}
